const GridCategoriesSkeleton: React.FC<any> = ({ viewRef, cmsComponentKey }) => {
  return (
    <div className="bg-surface-100-bg my-5" ref={viewRef} data-module={cmsComponentKey}>
      <div className="grid grid-cols-5 px-4 gap-y-2">
        {new Array(10).fill(0).map((_item, index) => {
          return (
            <div className="mx-auto" key={`grid-item-skleton-${index}`}>
              <div className="w-14 h-14 mx-auto my-0 rounded-[50%] bg-surface-200-bg" />
              <div className="bg-surface-200-bg mx-auto mt-1 h-[15px] w-[56px]" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GridCategoriesSkeleton;
